<template>
  <!-- CPAP 転院情報詳細 -->
  <div id="CpapHospitalTransfer">
    <div :id="getContainerType()">
      <div class="labelTitle lable">CPAP 転院申込み</div>
      <div class="button-area"><b-button class="backButton is-primary" @click="back">戻る</b-button></div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr>
              <th>転院予定月<span class="require"/></th>
              <td>
                <input type="month" v-model="data.transferDate" class="1" name="転院予定月" validate="required|month" style="width:150px;"/>
              </td>
            </tr>
            <template v-if="!data.isTransferUndecided">
              <tr/>
              <tr>
                <th>転院先医療機関</th>
                <td>
                  <input type="text" style="width:730px;" name="医療機関名" disabled v-model="data.transferDestinationName"/>
                  <b-button style="margin-left:10px; width:150px; height:27px;" @click="setOrganizationModal()">医療機関選択</b-button>
                </td>
              </tr>
              <tr><th/>
                <td>
                  <input type="text" style="width:730px;" name="医療機関住所" disabled v-model="data.transferDestinationAddress"/>
                </td>
              </tr>
              <tr><th/>
                <td>
                  <input type="text" style="width:730px;" name="医療機関電話番号" disabled v-model="data.transferDestinationPhoneNumber"/>
                </td>
              </tr>
            </template>
              <tr/>
              <tr>
                <th colspan=2>転院先が決まっていない / 転院先医療機関が見つからない　
                <b-checkbox class="cstmCheckBox" v-model="data.isTransferUndecided"></b-checkbox></th>
              </tr>
            <tr/>
            <tr>
              <th style="vertical-align:top;">申送り事項</th>
              <td v-if="data.isTransferUndecided">
                <textarea maxlength="256" style="resize:vertical;max-width:97%;height:130px;" v-model="data.transferMemo"
                  placeholder="・転院先が決まっていない場合、転院先の条件（地域やご希望の最寄り駅、土日診療有無など）あればご記載をお願いいたします。

・転院先医療機関にない施設を希望される場合は、医療機関名と医療機関住所（都道府県・市町村）をこちらにご記載ください。
　医療機関名：〇〇会〇〇クリニック
　住所　　　：〇〇県〇〇市〇〇町111－1〇〇ビル"></textarea>
              </td>
              <td v-else>
                <textarea maxlength="256" style="resize:vertical;max-width:97%;height:130px;" v-model="data.transferMemo"></textarea>
              </td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button class="is-primary" v-if="undecidedFlg" v-on:click="hospitalDecision">転院先決定</b-button>
          <b-button class="is-primary" v-else @click="changeHospital">申込む</b-button>
        </div>
        <div class="card-content margin-top">
          <span style="font-size:20px;">患者情報</span>
          <table>
            <tr>
              <th>患者コード</th>
              <td>{{data.patientCode}}</td>
            </tr>
            <tr>
              <th>患者名</th>
              <td>{{data.patientName}}</td>
            </tr>
            <tr>
              <th>住所</th>
              <td>{{data.patient.address}}</td>
            </tr>
            <tr>
              <th>電話番号</th>
              <td>{{data.patient.phoneNumber}}</td>
            </tr>
            <tr>
              <th>携帯電話</th>
              <td>{{data.patient.mobilePhone}}</td>
            </tr>
            <tr>
              <th>誕生日</th>
              <td>{{convertDate(data.patient.birthday)}}</td>
            </tr>
            <tr>
              <th>年齢</th>
              <td>{{data.patient.age}}</td>
            </tr>
            <tr>
              <th>性別</th>
              <td>{{data.patient.gender}}</td>
            </tr>
            <tr>
              <th>転院元医療機関</th>
              <td>{{data.medicalInstitutionName}}</td>
            </tr>
            <tr v-if="isHonsha || isAdmin || isSalesOffice">
              <th>コメント</th>
              <td>{{data.note}}</td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button v-if="data.changeHospital" class="is-primary" style="margin-left:10%;" @click="cancelReasonInputModalActive=true">キャンセル</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
    <b-modal :active.sync="extOrganizationModalActive" has-modal-card>
      <extOrganizationSelectModal :serviceId="serviceId" title="医療機関選択" :exclusionId="data.belongsId" :displayMail="false" :agreedInfoDisclosure="isHospital || isDealer" :transferFlg="true" @select="setHospital" ></extOrganizationSelectModal>
    </b-modal>
    <b-modal :active.sync="intOrganizationModalActive" has-modal-card>
      <intOrganizationSelectModal :selectRole="[role.role_hospital]" :selectStatus="extUserStatus.registed" :serviceId="serviceId" title="医療機関選択" labelForOrg="医療機関名" @select="setHospital" :exclusionId="data.belongsId" :agreedInfoDisclosure="isHospital || isDealer" :transferFlg="true"></intOrganizationSelectModal>
    </b-modal>
    <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
      <reasonInputModal  v-on:setReason="cancel" v-bind:title="'キャンセル理由入力'"></reasonInputModal>
    </b-modal>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import {extUserStatus} from "@/components/mock/base/const.js";
import intOrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";
import extOrganizationSelectModal from "@/components/mock/guest/OrganizationSelectModal";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import {service} from "@/components/mock/base/const.js";

export default {
  name: "CpapHospitalTransfer",
  methods: {
    getContainerType: function(){
      let type = "container";
      if(this.isHospital || this.isDealer){
        type = "container-center"
      }
      return type;
    },
    setOrganizationModal: function(){
      if(this.isHospital || this.isDealer){
        this.extOrganizationModalActive = true;
      } else {
        this.intOrganizationModalActive = true;
      }
    },
    back: function() {
      if (this.isHospital || this.isDealer) {
        this.$router.push({ 
          name: "CpapPatientDetail",
          params: { targetId:this.searchId, searchConditions: this.searchParams, isEscrow: this.isEscrow, ...(this.compleateFlg && { pdfDisplay: true })},
        });
      }else{
        this.$router.push({ 
          name: "CpapAgentPatientDetail",
          params: { targetId:this.searchId, searchConditions: this.searchParams, isEscrow: this.isEscrow, ...(this.compleateFlg && { pdfDisplay: true })},
        });
      }
    },
    convertDate: function(day){
      return day ? day.replace(/-/g, "/") : ""
    },
    changeHospital: function() {
      var elements = document.getElementsByClassName(1)
      var result = this.selfMadeValidation(elements)
      // QA427_エラーメッセージを一気に表示
      if (!this.data.isTransferUndecided && !this.data.transferDestinationName) {
        result.isError = true
        result.msg = result.msg + ("転院先医療機関を選択もしくは、<br/>「転院先が決まっていない/見つからない」に<br/>チェックをいれて、申送り事項にご記載ください。")
      }
      if (result.isError) {
        this.showErrorMessage(result.msg)
        return
      }

      // 申込み確認モーダル画面の表示メッセージ
      var message = "転院を申込みます。<br/>"
      // 転院先指定
      if (!this.data.isTransferUndecided) {
        // 転院先が医療機関、診療科の登録がある場合
        if (!this.data.transferInstitutionId && this.data.transferDepartmentName) {
          message += "<br/><span style='font-size: 20px;'><strong>" + this.data.transferMedicalInstitutionName + "</strong><br/></span>（" + this.data.transferDepartmentName + "）<br/>"
        } else {
          // 転院先がディーラー配下施設、または診療科の登録がない場合
          message += "<br/><span style='font-size: 20px;'><strong>" + this.data.transferMedicalInstitutionName + "</strong><br/></span>"
        }

        // 転院先医療機関住所
        message += this.data.transferDestinationAddress + "<br/>"

        // 内部ユーザーの場合、注記文を表示
        if (!this.isDealer && !this.isHospital) {
          message += "<span style='font-size: 13px;'>※転院先紹介機能がONの医療機関の場合はメールが送付されます。</span><br/><br/>"
        } else {
          message += "<br/>"
        }
      }

      message += "内容が正しいことを確認して「OK」ボタンを押してください。"

      this.$dialog.confirm({
        title: "申込み確認",
        message: message,
        cancelText: "修正する",
        onConfirm: async () => {
          this.compleateFlg = false;
          var excuteApi = this.setCpapTransferRequestPOST;
          var successCallBack = this.setCpapTransferRequestPOSTSuccess;
          var errorCallBack = this.setCpapTransferRequestPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
          if(this.compleateFlg){
            this.back()
          }
        }
      });
    },
    setCpapTransferRequestPOST: function(client) {
      return client.apis.externalCpap.setCpapTransferRequestPOST({
        body:{
          id:this.searchId,
          transferDate:this.data.transferDate ? this.data.transferDate.replace(/-/g, "/") :"",
          transferDestinationId:this.data.transferDestinationId,
          transferInstitutionId:this.data.transferInstitutionId,
          transferDestinationCode:this.data.transferDestinationCode ? this.data.transferDestinationCode : "",
          transferDestinationName:this.data.transferDestinationName,
          transferDestinationAddress:this.data.transferDestinationAddress,
          transferMemo:this.data.transferMemo,
          role : this.data.role,//ディーラー配下施設転院
          temp:this.temp,
          transferDestinationPhoneNumber:this.data.transferDestinationPhoneNumber,
          isTransferUndecided: this.data.isTransferUndecided,
        }
      });
    },
    setCpapTransferRequestPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.compleateFlg = true;
    },
    setCpapTransferRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    cancel: function(cancelReason) {
      // キャンセル
      this.reason = cancelReason
      var excuteApi = this.setCpapRequestCancelPOST;
      var successCallBack = this.setCpapRequestCancelPOSTSuccess;
      var errorCallBack = this.setCpapRequestCancelPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setCpapRequestCancelPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.reason = this.reason
      return client.apis.internalCpap.setCpapRequestCancelPOST({
        body:obj
      });
    },
    setCpapRequestCancelPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.back();
    },
    setCpapRequestCancelPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    setHospital: function(hospitalInfo){
      this.data.transferDestinationId = hospitalInfo.id
      this.data.transferInstitutionId = hospitalInfo.sstId//ディーラー配下施設転院
      this.data.transferDestinationCode = hospitalInfo.customerCode
      this.data.transferDestinationName = hospitalInfo.orgName
      this.data.role = hospitalInfo.role//ディーラー配下施設転院
      this.data.transferMedicalInstitutionName = hospitalInfo.medicalInstitutionName
      this.data.transferDepartmentName = hospitalInfo.departmentName
      this.data.transferDestinationAddress = hospitalInfo.prefecture + hospitalInfo.city + hospitalInfo.address + hospitalInfo.building
      this.data.transferDestinationPhoneNumber = hospitalInfo.phoneNumber
    },
    hospitalDecision: function(){
      // 転院先設定
      var elements = document.getElementsByClassName(1)
      var result = this.selfMadeValidation(elements)
      // QA427_エラーメッセージを一気に表示
      if (!this.data.isTransferUndecided && !this.data.transferDestinationName) {
        result.isError = true
        result.msg = result.msg + ("転院先医療機関を選択もしくは、<br/>「転院先が決まっていない/見つからない」に<br/>チェックをいれて、申送り事項にご記載ください。")
      }
      if (result.isError) {
        this.showErrorMessage(result.msg)
        return
      }

      // 申込み確認モーダル画面の表示メッセージ
      var message = "転院を申込みます。<br/>"
      // 転院先指定
      if (!this.data.isTransferUndecided) {
        // 転院先が医療機関、診療科の登録がある場合
        if (!this.data.transferInstitutionId && this.data.transferDepartmentName) {
          message += "<br/><span style='font-size: 20px;'><strong>" + this.data.transferMedicalInstitutionName + "</strong><br/></span>（" + this.data.transferDepartmentName + "）<br/>"
        } else {
          // 転院先がディーラー配下施設、または診療科の登録がない場合
          message += "<br/><span style='font-size: 20px;'><strong>" + this.data.transferMedicalInstitutionName + "</strong><br/></span>"
        }

        // 転院先医療機関住所
        message += this.data.transferDestinationAddress + "<br/>"

        // 内部ユーザーの場合、注記文を表示
        if (!this.isDealer && !this.isHospital) {
          message += "<span style='font-size: 13px;'>※転院先紹介機能がONの医療機関の場合はメールが送付されます。</span><br/><br/>"
        } else {
          message += "<br/>"
        }
      }

      message += "内容が正しいことを確認して「OK」ボタンを押してください。"

      this.$dialog.confirm({
        title: "申込み確認",
        message: message,
        cancelText: "修正する",
        onConfirm: async () => {
          this.compleateFlg = false;
          var excuteApi = this.setCpapTransferDestinationPOST;
          var successCallBack = this.setCpapTransferDestinationPOSTSuccess;
          var errorCallBack = this.setCpapTransferDestinationPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
          if (this.compleateFlg) {
            this.back()
          }
        }
      });
    },
    setCpapTransferDestinationPOST: function(client) {
      return client.apis.externalCpap.setCpapTransferDestinationPOST({
        body:{
          receiptNumber:this.data.receiptNumber,
          transferDate:this.data.transferDate ? this.data.transferDate.replace(/-/g, "/") :"",
          transferDestinationId:this.data.transferDestinationId,
          transferInstitutionId:this.data.transferInstitutionId,
          transferDestinationCode:this.data.transferDestinationCode ? this.data.transferDestinationCode : "",
          transferDestinationName:this.data.transferDestinationName,
          transferDestinationAddress:this.data.transferDestinationAddress,
          transferDestinationPhoneNumber:this.data.transferDestinationPhoneNumber,
          isTransferUndecided:this.data.isTransferUndecided,
          transferMemo:this.data.transferMemo,
          role:this.data.role,//ディーラー配下施設転院
        }
      });
    },
    setCpapTransferDestinationPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.back();
    },
    setCpapTransferDestinationPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  data() {
    var searchId = this.$route.params["targetId"];
    var searchParams = this.$route.params["searchConditions"];
    var selectedData = {}
    if(this.$route.params["selectedData"]){
      selectedData = this.$route.params["selectedData"];
    }
    // 仮持出申込み判定
    var temp = false;
    if(this.$route.params["temp"]){
      temp = this.$route.params["temp"];
    }
    if(!selectedData.transferDate){
      var today = new Date()
      selectedData.transferDate = today.getFullYear() + "-" + (today.getMonth() + 2)
    }else{
      var y = selectedData.transferDate.split("-")[0];
      var m = selectedData.transferDate.split("-")[1];
      selectedData.transferDate = y + "-" + m
    }
    var undecidedFlg = this.$route.params["isApplied"];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var isHospital = roleId == role.role_hospital;
    var isDealer = roleId == role.role_dealer;
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;
    const isEscrow = this.$route.params["isEscrow"]
    var serviceId = service.cpap;
    return {
      searchId,
      searchParams,
      data: selectedData,
      role: role,
      extUserStatus: extUserStatus,
      intOrganizationModalActive: false,
      extOrganizationModalActive: false,
      cancelReasonInputModalActive:false,
      roleId: roleId,
      userId: userId,
      isHospital: isHospital,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      reason:"",
      compleateFlg:false,
      temp,
      undecidedFlg,
      isEscrow,
      serviceId,
    };
  },
  filters: {},
  components: {
    extOrganizationSelectModal:extOrganizationSelectModal,
    intOrganizationSelectModal:intOrganizationSelectModal, 
    reasonInputModal:reasonInputModal
  },
  async mounted() {
  },
  watch: {
  },
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
a {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapHospitalTransfer.vue